import { Button, Container, Section } from '@react-email/components'

import { Email, Footer, Mapstack, Text } from '@ms-email/components'
import { borderRadius } from '@ms-email/themes/border-radius'
import { button } from '@ms-email/themes/button'
import { typography } from '@ms-email/themes/typography'
import { getFullname } from '@ms-email/utils/get-fullname'
import { baseUrl, getMapAccessApproveLink } from 'utils'

export function MapAccessRequest(props) {
  const { user, map } = props

  const fullname = getFullname(user)

  return (
    <Email
      title={`${user.firstName} has requested access to ${map.name} on Mapstack`}
      preview={'Map request access'}
    >
      <Container style={{ paddingBlock: 64 }}>
        <Mapstack />

        <Section
          style={{
            marginTop: 32,
            padding: 24,
            border: 'solid 1px',
            borderColor: 'rgba(0, 0, 0, 0.2)',
            borderRadius: borderRadius.rounded
          }}
        >
          <Text style={{ ...typography.body1 }}>
            Hi, {map.creator.firstName}
          </Text>
          <Text style={{ marginTop: 24, ...typography.body1 }}>
            <b>{fullname}</b> <b>({user.email})</b> has requested access to{' '}
            <b>{map.name}</b> on Mapstack
          </Text>
          <Button
            href={baseUrl() + getMapAccessApproveLink(user.id, map.id)}
            style={{
              marginTop: 24,
              ...button.primary('medium')
            }}
          >
            Process request
          </Button>
          <Text
            className='text-gray-400'
            style={{ marginTop: 24, ...typography.body2, fontWeight: 600 }}
          >
            Make sure that you trust external users before granting access.
          </Text>
        </Section>

        <Footer />
      </Container>
    </Email>
  )
}
